import { restClient } from '@/Core'
import { userManager } from '@/Core/Managers'

import { NO_CACHE, NOTIFICATIONS_URL, UNREAD_FILTER } from '../Helpers/notificationApi'
import { NotificationStore } from '../Stores/NotificationStore'

import type { NotificationListResponse } from '../Helpers/notificationApi'

/** Скільки непрочитаних — для дзвіночка. Один рядок, нам потрібен лише `meta.total`. */
export const LoadUnreadCountTask = async (): Promise<void> => {
    if (!userManager.user?.['uuid']) return

    try {
        const response = (await restClient.get(
            NOTIFICATIONS_URL,
            { searchParams: { page: 1, limit: 1, filters: UNREAD_FILTER } },
            NO_CACHE
        )) as unknown as NotificationListResponse | null

        NotificationStore.setUnreadCount(response?.meta?.total ?? 0)
    } catch (error) {
        console.warn('LoadUnreadCountTask error:', error)
    }
}
